module.exports = __webpack_public_path__ + "img/img_title_advantage_01.d6cd7a44.png";